<template>
  <div id="table-default" v-if="this.$authPermissions.includes('16')">
    <vs-table
      noDataText="Sem resultados"
      dense
      ref="table"
      search
      max-items="1000"
      pagination
      maxHeight="63vh"
      :data="rows"
    >
      <div
        slot="header"
        class="flex flex-wrap-reverse items-center flex-grow justify-between"
      >
        <div
          class="flex flex-wrap-reverse items-center data-list-btn-container"
        >
          <div class="vx-row">
            <div class="vx-col">
              <AddData
                :title="`Adicionar ${title}`"
                :url="url"
                @done="doneAddData"
              />
            </div>
            <div class="vx-col">
              <vs-button
                @click="
                  sendEmail();
                  filtro.lixeira = !filtro.lixeira;
                  getData();
                "
                class="w-full"
                :type="filtro.lixeira ? 'filled' : 'border'"
                :color="filtro.lixeira ? 'danger' : 'primary'"
                >Lixeira</vs-button
              >
            </div>
          </div>
        </div>
      </div>

      <template slot="thead">
        <vs-th width="1%" sort-key="id">I.D</vs-th>
        <vs-th width="20%" sort-key="nome">Nome</vs-th>
        <vs-th width="20%" sort-key="email">E-mail</vs-th>
        <vs-th width="20%" sort-key="perfil">Perfil</vs-th>
        <vs-th width="15%" sort-key="setor">Setor</vs-th>
        <vs-th width="12%" sort-key="setor">Bloqueado</vs-th>
        <vs-th width="15%">Ações</vs-th>
      </template>

      <template slot-scope="{ data }">
        <vs-tr
          :data="tr"
          :key="indextr"
          v-for="(tr, indextr) in data"
          :state="getRowColor(tr)"
        >
          <vs-td>
            <p class="row-max-width font-medium">{{ tr.id }}</p>
          </vs-td>
          <vs-td>
            <p class="row-max-width font-medium">{{ tr.nome }}</p>
          </vs-td>
          <vs-td>
            <p class="row-max-width font-medium">{{ tr.email }}</p>
          </vs-td>
          <vs-td>
            <p class="row-max-width font-medium">
              {{ tr.perfil }}
            </p>
          </vs-td>
          <vs-td>
            <p class="row-max-width font-medium">
              {{ tr.setor }}
            </p>
          </vs-td>
          <vs-td>
            <p class="row-max-width font-medium">
              {{ tr.bloqueado }}
            </p>
          </vs-td>
          <vs-td class="whitespace-no-wrap">
            <div class="vx-row">
              <div class="vx-col w-1/3" v-if="tr.lixeira != 1">
                <EditData
                  :title="`Editar ${title}`"
                  :url="url"
                  @done="doneEditData"
                  :itemCopy="tr"
                />
              </div>
              <div class="vx-col w-1/3">
                <vx-tooltip
                  :text="tr.lixeira != 1 ? 'Excluir' : 'Restaurar'"
                  color="primary"
                  position="left"
                >
                  <feather-icon
                    v-if="tr.lixeira != 1"
                    icon="TrashIcon"
                    svgClasses="hover:text-danger stroke-current mt-1 pointer"
                    @click.stop="deleteData(tr.id)"
                  />
                  <feather-icon
                    v-else
                    icon="RefreshCwIcon"
                    svgClasses="hover:text-success stroke-current mt-1 pointer"
                    @click.stop="restoreData(tr.id)"
                  />
                </vx-tooltip>
              </div>
              <div class="vx-col w-1/3">
                <vx-tooltip
                v-if="tr.bloqueado>='Sim'"
                  :text="'Desbloquear'"
                  color="primary"
                  position="left"
                >
                  <feather-icon               
                    icon="UnlockIcon"
                    svgClasses="hover:text-danger stroke-current mt-1 pointer"
                    @click.stop="unblock(tr.id)"
                  />
                  
                </vx-tooltip>
              </div>
            </div>
          </vs-td>
        </vs-tr>
      </template>
    </vs-table>
  </div>
</template>

<script>
import AddData from "./components/AddUsuario.vue";
import EditData from "./components/EditUsuario.vue";

export default {
  components: {
    AddData,
    EditData,
  },
  data() {
    return {
      rows: [],
      url: this.$route.meta.url,
      title: this.$route.meta.itemTitle,
      filtro: { lixeira: false },
    };
  },
  computed: {},
  methods: {
    getRowColor(item) {
      if (item.lixeira == 1) return "danger";
      // return "primary";
    },
    async doneAddData() {
      await this.getData();
    },
    async doneEditData() {
      await this.getData(0);
    },
    async getData(load = true) {
      load ? await this.$vs.loading() : 1;
      try {
        this.rows = await this.$http.get(
          `${this.url}?lixeira=${this.filtro.lixeira}`
        );
      } catch (err) {
        const error = this.$httpErrors(err);
        this.$vs.notify(error);
      } finally {
        load ? await this.$vs.loading.close() : 1;
      }
    },
    async deleteData(id) {
      await this.$vs.loading();
      try {
        await this.$http.delete(`${this.url}/${id}`);
        await this.getData(0);
      } catch (err) {
        const error = this.$httpErrors(err);
        this.$vs.notify(error);
      } finally {
        await this.$vs.loading.close();
      }
    },
    async unblock(id) {
      await this.$vs.loading();
      try{
        await this.$http.put(`${this.url}/${id}`, { tentativa: 0 })
        await this.getData(0)
      }catch (err){
        const error = this.$http(error)
        this.$vs.notify(error)
      }finally{
        await this.$vs.loading.close()
      }
    },
    async restoreData(id) {
      await this.$vs.loading();
      try {
        await this.$http.put(`${this.url}/${id}`, { lixeira: 0 });
        await this.getData(0);
      } catch (err) {
        const error = this.$httpErrors(err);
        this.$vs.notify(error);
      } finally {
        await this.$vs.loading.close();
      }
    },

    async sendEmail() {
      await this.$vs.loading();
      try {
        await this.$http.post(`test-email`, { lixeira: 0 });
      } catch (err) {
        const error = this.$httpErrors(err);
        this.$vs.notify(error);
      } finally {
        await this.$vs.loading.close();
      }
    },
  },
  created() {},
  async mounted() {
    await this.getData();
  },
};
</script>
